import React from "react";
import contextProvider from "../../contextProvider";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../_L0_components/Widgets/_LoadingKit";
import ReactOButton from "../../_L1_components/Elements/ReactOButton";
import ReactOActionBar from "../../_L1_components/Elements/ReactOActionBar";
import ReactOTooltip from "../../_L1_components/Elements/ReactOTooltip";
import ReactOForm from "../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../_L1_components/Elements/ReactOFormInput";
import Section from "../../_L1_components/Layout/Section";
import Panel from "../../_L1_components/Layout/Panel";
import MeasuresOveralsList from "../Elements/MeasuresOveralsList";
import MeasureBssidsList from "../Elements/MeasureBssidsList";
import {
  Badge,
  Row,
  Col,
  Input,
  ButtonGroup,
  FormFeedback,
  FormText,
} from "reactstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";

class ProbeMeasures extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: true,
      tagsView: true,
      persistentTags: false,
      data: {},
      msgCopy: "Copy link",
      countTag: [],
      selectedTags: [],
      filteredDataTags: [],
      searchKey: "",
      showInputTime: false,
      range: undefined,
      isCustom: false,
      invalidCustomRange: false,
      invalidCustomRangeMsg: "",
      viewRangeData: null,
    };
    super(props, initState);

    this.dateRangePicker = React.createRef();
    this.apiStore = null;
    this.orderedTags = [];
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    let defaultPreset = {};
    const currProbeid = this.props.match.params.probeuid;
    const prevProbeid = this.getAppContext()
      .getLocalStorageService()
      .get("goBackProbeid");
    const cachedPreset = this.getAppContext()
      .getLocalStorageService()
      .get("measure_graph_view");
    if (!cachedPreset) {
      defaultPreset = {
        stime: this.getAppContext().momentjs().unix(),
        etime: this.getAppContext().momentjs().unix(),
        is_preset: "yes",
        view_preset: 3600 * 4,
      };
      this.getAppContext()
        .getLocalStorageService()
        .set("measure_graph_view", defaultPreset);
    }
    if (prevProbeid && prevProbeid !== currProbeid) {
      this.getAppContext().getLocalStorageService().remove("goBackTags");
      this.getAppContext().getLocalStorageService().remove("goBackProbeid");
    }
    this.mounted = true;
    this.apiStore = this.getAppContext().getApiStoreService();
    this._view_form.init(defaultPreset);
    this._view_form.submit();
    // this.getProbeConf();
    // this.loadProbeInfo();
  }

  componentDidUpdate(prev_props) {
    if (
      this.props.match.params.status != prev_props.match.params.status &&
      this._view_form
    ) {
      if (this._CURR_status_view !== undefined) {
        this._view_form.submit();
      }
    }
    if (
      (prev_props.match.params.probeuid !== undefined &&
        prev_props.match.params.probeuid != this.props.match.params.probeuid) ||
      (prev_props.match.params.measureid !== undefined &&
        prev_props.match.params.measureid !=
          this.props.match.params.measureid) ||
      prev_props.match.params.status !== this.props.match.params.status
    ) {
      this.getAppContext().getLocalStorageService().remove("goBackTags");
      this.getAppContext().getLocalStorageService().remove("goBackProbeid");
      this.getAppContext().getLocalStorageService().remove("prevSelectedTags");
      this.setState(
        {
          countTag: [],
          selectedTags: [],
          filteredDataTags: [],
          searchKey: "",
          tagsView: true,
          persistentTags: false,
        },
        () => {
          this._view_form.submit();
        },
      );
    }
  }

  handleMeasuresWithoutTags(value) {
    const newFilteredData =
      value == "on"
        ? this.state.data.online.filter((item) => item.tags == "")
        : this.state.data.online;
    this.formatAnomaliesData(newFilteredData);
    this.setState({ filteredData: newFilteredData });
  }

  getTagCounts = (array) => {
    const counter = {};
    array.forEach((elem) => {
      const tags = elem.tags ? [...new Set(elem.tags)] : [];
      tags.forEach((tag) => {
        counter[tag] = (counter[tag] || 0) + 1;
      });
    });
    return counter;
  };

  getMlist(measures) {
    let mlist = {};
    measures.forEach(({ prb_id, cssid }) => {
      if (mlist[prb_id]) {
        mlist[prb_id].push(cssid);
      } else {
        mlist[prb_id] = [cssid];
      }
    });
    return mlist;
  }

  getAllTags(data) {
    const allTagsSet = new Set();
    data.forEach((obj) => {
      let tags = obj.tags || [];
      tags.forEach((tag) => allTagsSet.add(tag));
    });
    return Array.from(allTagsSet);
  }

  loadMeasuresList(data, cb, opts) {
    this.getAppContext()
      .getLocalStorageService()
      .set("measure_graph_view", data);

    const goBackTags = this.getAppContext()
      .getLocalStorageService()
      .get("goBackTags");
    const prevSelectedTags = this.getAppContext()
      .getLocalStorageService()
      .get("prevSelectedTags");

    let selectedTags = goBackTags?.selectedTags || prevSelectedTags || [];

    const resetData = {
      selectedTags,
      filteredDataTags: [],
      persistentTags: false,
    };
    this.setState(
      {
        loading: true,
        conf_set: undefined,
        viewrange: data,
        ...(!this._IS_AUTO_RELOADING ? resetData : { persistentTags: true }),
      },
      () => {
        this.apiStore.fire(
          this.props.match.params.status == "archived"
            ? "get_archived_measures_list"
            : this.props.match.params.status == "paused"
              ? "get_paused_measures_list"
              : "get_measures_list",
          {
            no_error_handle: opts ? opts.no_error_handle : false,
            data: {
              probeuid: this.props.match.params.probeuid,
              measureid: this.props.match.params.measureid || "overal",
              viewrange: data,
            },
            ___onSuccess: (_, response_data) => {
              const measures = response_data.measures_list || [];
              // TAGS
              const tagCounts = this.getTagCounts(measures);
              const measuresWithNoTags = measures
                .filter((elem) => !elem.paused)
                .filter((e) => !e.tags || e.tags.length == 0);

              const filteredDataTags = measures
                // .filter((elem) => !elem.paused)
                .filter((item) => {
                  return selectedTags.every((selectedTag) =>
                    item.tags?.includes(selectedTag),
                  );
                });

              this.orderedTags = Object.entries(tagCounts)
                .sort((a, b) => {
                  const countDiff = b[1] - a[1];
                  return countDiff !== 0 ? countDiff : a[0].localeCompare(b[0]);
                })
                .map(([tag]) => tag);
              let countTag = this.getAllTags(measures);
              // ----
              let freqData = undefined;
              let filteredData = undefined;
              if (measures) {
                filteredData = measures.find((_C_entry) => {
                  return _C_entry.cssid == this.props.match.params.measureid;
                });
                // console.log("filteredData", filteredData);
                if (filteredData && filteredData.dataPerBssid) {
                  freqData = filteredData.dataPerBssid
                    .filter((elem) => {
                      return elem.last_freq;
                    })
                    .reduce((sums, entry) => {
                      let { curr_f } = entry.last_freq;
                      if (curr_f < 5000) {
                        sums["2.4"] = (sums["2.4"] || 0) + 1;
                      } else if (curr_f < 5925) {
                        sums["5"] = (sums["5"] || 0) + 1;
                      } else {
                        sums["6"] = (sums["6"] || 0) + 1;
                      }
                      return sums;
                    }, {});
                }
              }

              if (this.mounted) {
                this.getAppContext()
                  .getLocalStorageService()
                  .remove("goBackTags");
                this.getProbeConf();

                this.setState(
                  {
                    data: response_data,
                    filteredDataTags,
                    filteredData: filteredData ? filteredData : undefined,
                    freqData: freqData,
                    measuresWithNoTags,
                    loading: false,
                    persistentTags: true,
                    countTag,
                    ...(!this._IS_AUTO_RELOADING
                      ? { showInputTime: false, range: undefined }
                      : {}),
                  },
                  () => {
                    if (this.toggleViewForm) this.toggleViewForm.init();
                    // if (this.showTags_form) this.showTags_form.init();
                  },
                );
              }
            },
            ___onError: (status, response) => {
              console.error(
                " :: _ReactOBaseComponent _ render [ERROR PRE LOADING COMMONS] - for:",
              );
              console.error("response:  ", response);
            },
            ___onEnd: () => {
              if (this._IS_AUTO_RELOADING) {
                this._IS_AUTO_RELOADING = false;
              }
              if (this._AUTO_RELOAD_TIMEOUT) {
                clearTimeout(this._AUTO_RELOAD_TIMEOUT);
              }
              if (data.is_preset == "yes" && !data.offset) {
                this._AUTO_RELOAD_TIMEOUT = setTimeout(() => {
                  this._IS_AUTO_RELOADING = true;
                  this._view_form.submit(null, { no_error_handle: true });
                }, 60000);
              }
            },
          },
        );
      },
    );
  }

  getProbeConf() {
    this.apiStore.fire("probe_cst_sync_status", {
      data: {
        probeuid: this.props.match.params.probeuid,
      },
      ___onSuccess: (status, data) => {
        if (this.mounted) {
          this.setState((prev_state) => {
            prev_state.conf_set = data;
            return prev_state;
          });
        }
      },
    });
  }

  loadProbeInfo() {
    this.setState(
      {
        probe_info_loading: true,
      },
      () => {
        this.apiStore.fire("probes", {
          data: {
            probeuid: this.props.match.params.probeuid,
          },
          ___onSuccess: (status, data) => {
            if (this.mounted) {
              this.setState({
                probe_info_data: data,
                probe_info_loading: false,
              });
            }
          },
        });
      },
    );
  }

  checkFutureTime(etime) {
    const now =
      this._measureInfo?.paused ||
      this._measureInfo?.archived ||
      this.getAppContext().momentjs().unix();
    const normalizeToMinute = (epoch) => Math.floor(epoch / 60);
    return normalizeToMinute(etime) >= normalizeToMinute(now);
  }

  parseTime() {
    if (
      this._view_form &&
      this._view_form.isInitialized() &&
      this.state.viewRangeData
    ) {
      const is_preset = this._view_form.getEntry("is_preset");
      let from_ts = this.state.viewRangeData.stime;
      let to_ts = this.state.viewRangeData.etime;

      let _stime = from_ts
        ? this.getAppContext().momentjs(from_ts, "X").format("L LT")
        : "";

      let startDate = from_ts
        ? this.getAppContext().momentjs(from_ts, "X").format("L")
        : "";

      let _etime = to_ts
        ? this.getAppContext().momentjs(to_ts, "X").format("L LT")
        : "";

      let endDate = to_ts
        ? this.getAppContext().momentjs(to_ts, "X").format("L")
        : "";

      if (
        startDate == endDate &&
        !this.state.showInputTime &&
        is_preset == "yes"
      ) {
        let _text = to_ts
          ? _stime +
            " - " +
            this.getAppContext().momentjs(to_ts, "X").format("LT")
          : "";
        return _text;
      } else {
        let _text = _stime + " - " + _etime;
        return _text;
      }
    } else {
      return null;
    }
  }

  handleCustomRange() {
    return this.state.range !== undefined ? this.state.range : this.parseTime();
  }

  submitCustomRange() {
    let start = this.state.range.split("-")[0];
    let end = this.state.range.split("-")[1];

    if (
      this.getAppContext().momentjs(start, "L LT").isValid() &&
      this.getAppContext().momentjs(end, "L LT").isValid()
    ) {
      let start_customTime = this.getAppContext()
        .momentjs(start, "L LT")
        .unix();
      let end_customTime = this.getAppContext().momentjs(end, "L LT").unix();

      try {
        if (
          start_customTime &&
          end_customTime &&
          end_customTime > start_customTime
        ) {
          this._view_form.handleFormChange("is_preset", "no");
          this._view_form.handleFormChange("view_preset", "no");
          this._view_form.handleFormChange("offset", false);
          this._view_form.handleFormChange("stime", start_customTime);
          this._view_form.handleFormChange("etime", end_customTime);
          this._view_form.handleFormChange("snapStime", "");
          this._view_form.handleFormChange("snapEtime", "");
          this._view_form.submit();
          this.setState({ showInputTime: false, range: undefined });
        } else {
          throw new Error("Data interval not valid");
        }
      } catch (err) {
        console.error(err.message);
        this.setState({
          invalidCustomRange: true,
          invalidCustomRangeMsg: "Data interval not valid",
        });
      }
    } else {
      this.setState({
        invalidCustomRange: true,
        invalidCustomRangeMsg:
          "Sample date format: " +
          this.getAppContext().momentjs().format("L LT"),
      });
    }
  }

  onComponentWillUnmount() {
    // console.log("unmount");
    this.mounted = false;
    if (this._AUTO_RELOAD_TIMEOUT) {
      clearTimeout(this._AUTO_RELOAD_TIMEOUT);
    }
    if (this.getAppContext().getLocalStorageService().get("goBackTags")) {
      this.getAppContext().getLocalStorageService().remove("goBackTags");
    }
    // if (this.getAppContext().getLocalStorageService().get("prevSelectedTags")) {
    //   this.getAppContext().getLocalStorageService().remove("prevSelectedTags");
    // }
  }
  handleTagClick = (tag) => {
    if (this.getAppContext().getLocalStorageService().get("goBackTags")) {
      this.getAppContext().getLocalStorageService().remove("goBackTags");
    }

    this.setState((prevState) => {
      const alreadySelected = prevState.selectedTags.includes(tag);
      const newSelectedTags = alreadySelected
        ? prevState.selectedTags.filter((t) => t !== tag)
        : [...prevState.selectedTags, tag];

      const newFilteredData = this.state.data.measures_list
        // .filter((item) => !item.paused)
        .filter((item) => item.tags)
        .filter((item) => {
          return newSelectedTags.every((selectedTag) =>
            item.tags.includes(selectedTag),
          );
        });
      this.getAppContext()
        .getLocalStorageService()
        .set("prevSelectedTags", newSelectedTags);
      return {
        selectedTags: newSelectedTags,
        filteredDataTags: newFilteredData,
        searchKey: "",
      };
    });
  };

  getDisabledTags = () => {
    const { selectedTags, filteredDataTags } = this.state;
    const disabled = {};

    if (selectedTags.length === 0) return disabled;

    const coexistingTags = new Set();
    filteredDataTags.forEach((obj) => {
      let tags = obj.tags || [];
      tags.forEach((tag) => coexistingTags.add(tag));
    });

    this.state.countTag.forEach((tag) => {
      if (!selectedTags.includes(tag) && !coexistingTags.has(tag)) {
        disabled[tag] = true;
      }
    });

    return disabled;
  };

  onRender() {
    if (
      this.props.match.params.status != this._CURR_status_view &&
      this._view_form
    ) {
      if (this._CURR_status_view !== undefined) {
        this._view_form.submit();
      }
      this._CURR_status_view = this.props.match.params.status;
    }
    // if (
    //   (this._CURR_probeuid !== undefined &&
    //     this._CURR_probeuid != this.props.match.params.probeuid) ||
    //   (this._CURR_measureid !== undefined &&
    //     this._CURR_measureid != this.props.match.params.measureid)
    // ) {
    //   console.log("render 2");
    //   this._view_form.submit();
    // }
    this._CURR_probeuid = this.props.match.params.probeuid;
    this._CURR_measureid = this.props.match.params.measureid;

    const tagCounts = this.getTagCounts(this.state.filteredDataTags);
    const disabledTags = this.getDisabledTags(tagCounts);
    const tests = this.state.filteredDataTags.reduce(
      (acc, cur) => (acc.includes(cur.test) ? acc : [...acc, cur.test]),
      [],
    );
    const dataLength = this.state.filteredDataTags.length;
    const mlist = this.getMlist(this.state.filteredDataTags);
    const search = this.state.countTag.filter((elem) =>
      elem.toLowerCase().includes(this.state.searchKey.toLowerCase()),
    );
    return (
      <Section designType="wide">
        <Section
          designType="wide"
          className="mb-4 border-bottom border-3 border-gray300"
        >
          {this.props.match.params.measureid
            ? (() => {
                this._measureInfo = [];
                if (this.state.data.measures_list) {
                  let _current_measure_data =
                    this.state.data.measures_list.find((_C_entry) => {
                      return (
                        _C_entry.cssid == this.props.match.params.measureid
                      );
                    });
                  this._measureInfo = _current_measure_data
                    ? {
                        name: _current_measure_data.name,
                        essid: _current_measure_data.essid,
                        archived: _current_measure_data.archived,
                        paused: _current_measure_data.paused,
                        connection_criteria:
                          _current_measure_data.connection_criteria,
                        test: _current_measure_data.test,
                        tags: _current_measure_data.tags || [],
                      }
                    : {};
                  //this._measureInfo = this.state.data.measures_list;
                }
                return (
                  <div>
                    <div
                      className={
                        "px-4 pt-4 pb-3" +
                        (this.getAppContext().media.isMobile ||
                        this.getAppContext().media.isTablet
                          ? ""
                          : " d-flex")
                      }
                    >
                      <div className="flex-grow-1">
                        <h2>{this._measureInfo.name || "-"}</h2>

                        <small className="text-left d-flex align-items-center mt-2">
                          <Section
                            className={
                              this.getAppContext().media.isMobile ||
                              this.getAppContext().media.isTablet
                                ? "flex-grow-1"
                                : ""
                            }
                            designType="wide"
                            layoutManager="grid"
                            elementsPerRow={
                              this.getAppContext().media.isMobile ||
                              this.getAppContext().media.isTablet
                                ? 1
                                : 5
                            }
                            gridSpacing={1}
                            gridSpacingColor={
                              this.getAppContext().colors.gray300
                            }
                          >
                            <div
                              className={
                                "flex-shrink-1 py-1" +
                                (!this.getAppContext().media.isMobile &&
                                !this.getAppContext().media.isTablet
                                  ? " px-2"
                                  : "")
                              }
                            >
                              <strong className="text-muted">NETWORK:</strong>
                              <strong className="pl-2">
                                <span className="text-nowrap">
                                  {this._measureInfo.essid || "-"}
                                </span>
                              </strong>
                            </div>
                            <div
                              className={
                                "flex-shrink-1 py-1" +
                                (!this.getAppContext().media.isMobile &&
                                !this.getAppContext().media.isTablet
                                  ? " px-2"
                                  : "")
                              }
                            >
                              <strong className="text-muted text-nowrap">
                                CONNECTION CRITERIA:
                              </strong>
                              <strong className="pl-2">
                                <span
                                  id={
                                    typeof this._measureInfo
                                      .connection_criteria == "object"
                                      ? "_tooltip_multi_ap_conn_crit_"
                                      : null
                                  }
                                >
                                  {typeof this._measureInfo
                                    .connection_criteria == "object" ? (
                                    <span className="text-nowrap">
                                      Multi AP
                                      <ReactOTooltip
                                        placement="bottom"
                                        target="_tooltip_multi_ap_conn_crit_"
                                        text={Object.keys(
                                          this._measureInfo.connection_criteria,
                                        ).map((_C_bssid, _C_idx) => {
                                          return (
                                            <div
                                              key={_C_idx}
                                              className="text-nowrap"
                                            >
                                              <strong>{_C_bssid}</strong>
                                              {this._measureInfo
                                                .connection_criteria[
                                                _C_bssid
                                              ] ? (
                                                <span className="text-muted ml-2">
                                                  (
                                                  {this._measureInfo
                                                    .connection_criteria[
                                                    _C_bssid
                                                  ].ap_custom_data
                                                    ? this._measureInfo
                                                        .connection_criteria[
                                                        _C_bssid
                                                      ].ap_custom_data.name
                                                    : this._measureInfo
                                                        .connection_criteria[
                                                        _C_bssid
                                                      ].short_desc}
                                                  )
                                                </span>
                                              ) : null}
                                            </div>
                                          );
                                        })}
                                      />
                                      <span className="sub-title icon-info ml-2" />
                                    </span>
                                  ) : this._measureInfo.connection_criteria ? (
                                    <span className="text-nowrap">
                                      {this._measureInfo.connection_criteria}
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </span>
                              </strong>
                            </div>
                            <div
                              className={
                                "flex-shrink-1 py-1" +
                                (!this.getAppContext().media.isMobile &&
                                !this.getAppContext().media.isTablet
                                  ? " px-2"
                                  : "")
                              }
                            >
                              <strong className="text-muted">TEST:</strong>
                              <strong className="pl-2">
                                <span className="text-nowrap">
                                  {this._measureInfo.test || "-"}
                                </span>
                              </strong>
                            </div>

                            {this.getAppContext().authHandler.getAccountData()
                              .smart_notifications &&
                              this.getAppContext().authHandler.getAccountData()
                                .smart_notifications == "yes" && (
                                <div
                                  className={
                                    "d-flex flex-shrink-1 py-1" +
                                    (!this.getAppContext().media.isMobile &&
                                    !this.getAppContext().media.isTablet
                                      ? " px-2"
                                      : "")
                                  }
                                >
                                  {this._measureInfo.tags &&
                                    this._measureInfo.tags.length > 0 && (
                                      <>
                                        <strong className="text-muted">
                                          TAGS:
                                        </strong>
                                        <strong className="pl-2">
                                          <span className="text-nowrap">
                                            {this._measureInfo.tags
                                              .sort((a, b) =>
                                                a.localeCompare(b, "it", {
                                                  sensitivity: "base",
                                                }),
                                              )
                                              .map((tag) => {
                                                return (
                                                  <Badge
                                                    key={tag}
                                                    style={{
                                                      fontSize: "14px",
                                                      // cursor: this.state.loading
                                                      //   ? "unset"
                                                      //   : "pointer",
                                                      // color: "#a1a9b0",
                                                      fontWeight: "400",
                                                    }}
                                                    pill
                                                    // onClick={() => {
                                                    //   if (!this.state.loading) {
                                                    //     this.handleTagClick(
                                                    //       tag
                                                    //     );
                                                    //   }
                                                    // }}
                                                    className={`border border-1 border-gray700 text-gray800 mr-2 mb-1 bg-white`}
                                                  >
                                                    <strong>{tag}</strong>
                                                  </Badge>
                                                );
                                              })}
                                          </span>
                                        </strong>
                                      </>
                                    )}
                                </div>
                              )}

                            {this.props.match.params.status == "paused" ? (
                              <div
                                className={
                                  "flex-shrink-1 py-1 text-orange text-nowrap" +
                                  (!this.getAppContext().media.isMobile &&
                                  !this.getAppContext().media.isTablet
                                    ? " px-2"
                                    : "")
                                }
                              >
                                <strong className="">
                                  <span className="icon-pause mr-2" />
                                  PAUSED AT:
                                </strong>
                                <strong className="pl-2">
                                  <span className="text-nowrap">
                                    {this._measureInfo.paused
                                      ? this.getAppContext()
                                          .momentjs(
                                            this._measureInfo.paused,
                                            "X",
                                          )
                                          .format("L LT")
                                      : "-"}
                                  </span>
                                </strong>
                              </div>
                            ) : this.props.match.params.status == "archived" ? (
                              <div
                                className={
                                  "flex-shrink-1 py-1 text-orange text-nowrap" +
                                  (!this.getAppContext().media.isMobile &&
                                  !this.getAppContext().media.isTablet
                                    ? " px-2"
                                    : "")
                                }
                              >
                                <strong className="">
                                  <span className="icon-archive mr-2" />
                                  ARCHIVED AT:
                                </strong>
                                <strong className="pl-2">
                                  <span className="text-nowrap">
                                    {this._measureInfo.archived
                                      ? this.getAppContext()
                                          .momentjs(
                                            this._measureInfo.archived,
                                            "X",
                                          )
                                          .format("L LT")
                                      : "-"}
                                  </span>
                                </strong>
                              </div>
                            ) : null}
                            <div className="flex-grow-1 h-100 d-flex align-items-center">
                              <ReactOActionBar padding="0">
                                <LinkContainer
                                  to={{
                                    pathname:
                                      "/" +
                                      this.props.match.params.probeuid +
                                      "/config/" +
                                      this.props.match.params.measureid,
                                    state: {
                                      prevPath: window.location.pathname,
                                    },
                                  }}
                                  activeClassName=""
                                >
                                  <ReactOButton
                                    icon={
                                      this.state.conf_set &&
                                      this.state.conf_set.measures_conf
                                        ? this.state.conf_set.measures_conf ==
                                          "SD"
                                          ? "eye-lateral"
                                          : "pencil"
                                        : ""
                                    }
                                    color="white"
                                    title={
                                      this.state.conf_set &&
                                      this.state.conf_set.measures_conf
                                        ? this.state.conf_set.measures_conf ==
                                          "SD"
                                          ? "View"
                                          : "Modify"
                                        : ""
                                    }
                                    size="sm"
                                  />
                                </LinkContainer>
                              </ReactOActionBar>
                            </div>
                          </Section>
                        </small>
                      </div>
                    </div>
                  </div>
                );
              })()
            : (() => {
                this._measureInfo = undefined;
                return (
                  <div>
                    <div className="d-flex align-items-baseline px-4 pt-4 pb-3">
                      <h2>
                        {this.state.filteredDataTags.length > 0
                          ? `${this.state.filteredDataTags.length} `
                          : ""}
                        {this.props.match.params.status == "archived"
                          ? "Archived and paused measures "
                          : "Active measures "}
                        {this.state.selectedTags.length > 0 &&
                          "for tag selection"}
                      </h2>
                    </div>
                  </div>
                );
              })()}
        </Section>
        <Section className="mx-4 mb-2" designType="wide">
          <div className="d-flex">
            <div className="flex-grow-1">
              <ReactOForm
                onControllerReady={(form_controller) => {
                  this._view_form = form_controller;
                }}
                onSubmit={(data, submit_cb, opt) => {
                  let viewRangeData;
                  if (data.is_preset == "yes") {
                    let startDate =
                      this.getAppContext().momentjs().unix() - data.view_preset;
                    viewRangeData = {
                      stime: startDate,
                      etime: this.getAppContext().momentjs().unix(),
                    };
                  } else {
                    viewRangeData = {
                      stime: parseInt(data.stime),
                      etime: parseInt(data.etime),
                    };
                  }
                  if (this.dateRangePicker.current) {
                    this.dateRangePicker.current.setStartDate(
                      this.getAppContext().momentjs(viewRangeData.stime, "X"),
                    );
                    this.dateRangePicker.current.setEndDate(
                      this.getAppContext().momentjs(viewRangeData.etime, "X"),
                    );
                  }
                  this.setState({ viewRangeData });
                  this.loadMeasuresList(data, submit_cb, opt);
                }}
              >
                <ReactOFormInput type="hidden" data_key="snapStime" />
                <ReactOFormInput type="hidden" data_key="snapEtime" />
                <ReactOFormInput
                  type="hidden"
                  data_key="stime"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").stime
                      : this.getAppContext().momentjs().unix()
                  }
                />
                <ReactOFormInput
                  type="hidden"
                  data_key="etime"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").etime
                      : this.getAppContext().momentjs().unix()
                  }
                />
                <ReactOFormInput
                  type="hidden"
                  data_key="offset"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").offset
                      : false
                  }
                />
                <ReactOFormInput
                  type="hidden"
                  data_key="is_preset"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").is_preset
                      : "yes"
                  }
                />
                <ReactOFormInput
                  type="hidden"
                  data_key="timeSnapshot"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").timeSnapshot
                      : false
                  }
                />

                <ReactOActionBar
                  padding="0"
                  alignV="start"
                  className="d-flex justify-content-between"
                >
                  <div className="d-flex align-items-start flex-wrap">
                    <ReactOFormInput
                      type="select"
                      inputClassName="select-w-150"
                      size={this.getAppContext().media.isMobile ? "sm" : ""}
                      data_key="view_preset"
                      color="primary"
                      nomarg
                      noSelectionLabel="Custom preset"
                      default={
                        this.getAppContext()
                          .getLocalStorageService()
                          .isSet("measure_graph_view")
                          ? this.getAppContext()
                              .getLocalStorageService()
                              .get("measure_graph_view").view_preset
                          : 3600 * 4
                      }
                      onOptionSelect={(form_ctrl, selected_value) => {
                        this.setState(
                          {
                            isCustom: false,
                            showInputTime: false,
                            invalidCustomRange: false,
                          },
                          () => {
                            form_ctrl.handleFormChange(
                              "view_preset",
                              selected_value,
                            );
                            form_ctrl.handleFormChange("is_preset", "yes");
                            form_ctrl.handleFormChange("offset", false);
                            form_ctrl.handleFormChange("snapStime", "");
                            form_ctrl.handleFormChange("snapEtime", "");
                            form_ctrl.submit();
                          },
                        );
                      }}
                      options={(form_data) => {
                        return [
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600
                                ? "1 hour"
                                : "Last hour",
                            value: 3600,
                          },
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600 * 4
                                ? "4 hours"
                                : "Last 4 hours",
                            value: 3600 * 4,
                          },
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600 * 24
                                ? "24 hours"
                                : "Last 24 hours",
                            value: 3600 * 24,
                          },
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600 * 24 * 7
                                ? "7 days"
                                : "Last 7 days",
                            value: 3600 * 24 * 7,
                          },
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600 * 24 * 7 * 4
                                ? "4 weeks"
                                : "Last 4 weeks",
                            value: 3600 * 24 * 7 * 4,
                          },
                        ];
                      }}
                    />

                    <div className="ml-2">
                      {(() => {
                        let _offset =
                          this._view_form && this._view_form.isInitialized()
                            ? this._view_form.getEntry("offset")
                            : 0;
                        let _currentRange = this.state.viewRangeData
                          ? this.state.viewRangeData.etime -
                            this.state.viewRangeData.stime
                          : 0;
                        return (
                          <ButtonGroup>
                            <ReactOButton
                              icon="navigate-prev"
                              color={
                                _offset !== undefined && _offset < 0
                                  ? "success"
                                  : "secondary"
                              }
                              outline={_offset === undefined || _offset >= 0}
                              disabled={
                                (this.state.loading &&
                                  !this._IS_AUTO_RELOADING) ||
                                !_currentRange
                              }
                              onClick={() => {
                                let _offset =
                                  this._view_form.getEntry("offset") || 0;
                                let timeSnapshot = this.getAppContext()
                                  .momentjs()
                                  .unix();
                                let _new_offset =
                                  _offset !== undefined
                                    ? _offset - _currentRange / 2
                                    : -_currentRange / 2;
                                this._view_form.handleFormChange(
                                  "offset",
                                  _new_offset == 0 ? false : _new_offset,
                                );
                                this._view_form.handleFormChange(
                                  "timeSnapshot",
                                  timeSnapshot,
                                );

                                let stime, etime;
                                if (this._view_form.getEntry("snapStime")) {
                                  stime = this._view_form.getEntry("snapStime");
                                  etime = this._view_form.getEntry("snapEtime");
                                } else {
                                  stime = this.state.viewRangeData.stime;
                                  etime = this.state.viewRangeData.etime;
                                  this._view_form.handleFormChange(
                                    "snapStime",
                                    stime,
                                  );
                                  this._view_form.handleFormChange(
                                    "snapEtime",
                                    etime,
                                  );
                                }

                                const offsetStime = stime + _new_offset;
                                const offsetEtime = etime + _new_offset;

                                this._view_form.handleFormChange(
                                  "is_preset",
                                  "no",
                                );
                                this._view_form.handleFormChange(
                                  "stime",
                                  offsetStime,
                                );
                                this._view_form.handleFormChange(
                                  "etime",
                                  offsetEtime,
                                );
                                this._view_form.submit();
                              }}
                            />
                            <ReactOButton
                              icon="navigate-next"
                              color={
                                _offset !== undefined && _offset > 0
                                  ? "success"
                                  : "secondary"
                              }
                              outline={_offset === undefined || _offset <= 0}
                              disabled={
                                this.state.loading ||
                                !_currentRange ||
                                (this.state.viewRangeData?.etime &&
                                  this.checkFutureTime(
                                    this.state.viewRangeData.etime,
                                  ))
                              }
                              onClick={() => {
                                let _offset =
                                  this._view_form.getEntry("offset") || 0;
                                let timeSnapshot = this.getAppContext()
                                  .momentjs()
                                  .unix();
                                let _new_offset =
                                  _offset !== undefined
                                    ? _offset + _currentRange / 2
                                    : _currentRange / 2;
                                this._view_form.handleFormChange(
                                  "offset",
                                  _new_offset == 0
                                    ? false
                                    : Math.round(_new_offset),
                                );
                                this._view_form.handleFormChange(
                                  "timeSnapshot",
                                  timeSnapshot,
                                );

                                let stime, etime;
                                if (this._view_form.getEntry("snapStime")) {
                                  stime = this._view_form.getEntry("snapStime");
                                  etime = this._view_form.getEntry("snapEtime");
                                } else {
                                  stime = this.state.viewRangeData.stime;
                                  etime = this.state.viewRangeData.etime;
                                  this._view_form.handleFormChange(
                                    "snapStime",
                                    stime,
                                  );
                                  this._view_form.handleFormChange(
                                    "snapEtime",
                                    etime,
                                  );
                                }

                                const offsetStime = stime + _new_offset;
                                const offsetEtime = etime + _new_offset;

                                this._view_form.handleFormChange(
                                  "is_preset",
                                  "no",
                                );
                                this._view_form.handleFormChange(
                                  "stime",
                                  offsetStime,
                                );
                                this._view_form.handleFormChange(
                                  "etime",
                                  offsetEtime,
                                );
                                this._view_form.submit();
                              }}
                            />
                          </ButtonGroup>
                        );
                      })()}
                    </div>

                    <span className="ml-2">
                      <DateRangePicker
                        initialSettings={{
                          startDate:
                            this._view_form &&
                            this._view_form.isInitialized() &&
                            this._view_form.getEntry("is_preset") == "no"
                              ? this.getAppContext().momentjs(
                                  this._view_form.getEntry("stime"),
                                  "X",
                                )
                              : this.getAppContext().momentjs(),
                          endDate:
                            this._view_form &&
                            this._view_form.isInitialized() &&
                            this._view_form.getEntry("is_preset") == "no"
                              ? this.getAppContext().momentjs(
                                  this._view_form.getEntry("etime"),
                                  "X",
                                )
                              : this.getAppContext().momentjs(),
                          autoApply: true,
                          maxDate: this.getAppContext()
                            .momentjs()
                            .startOf("day")
                            .toDate(),
                        }}
                        ref={this.dateRangePicker}
                        onApply={(e, picker) => {
                          let startDate = picker.startDate.unix();
                          let endDate = picker.endDate.unix() + 1;

                          this.setState(
                            {
                              showInputTime: false,
                              invalidCustomRange: false,
                            },
                            () => {
                              this._view_form.handleFormChange(
                                "is_preset",
                                "no",
                              );
                              this._view_form.handleFormChange(
                                "view_preset",
                                "no",
                              );
                              this._view_form.handleFormChange("offset", false);
                              this._view_form.handleFormChange(
                                "stime",
                                startDate,
                              );
                              this._view_form.handleFormChange(
                                "etime",
                                endDate,
                              );
                              this._view_form.submit();
                            },
                          );
                        }}
                      >
                        <button
                          id="_pm_drp"
                          disabled={
                            this.state.loading && !this._IS_AUTO_RELOADING
                          }
                          className="selected-date-range-btn text-nowrap nofocus btn btn-outline-secondary mr-2"
                        >
                          <span className="icon-calendar" />
                        </button>
                      </DateRangePicker>
                    </span>
                    <ReactOTooltip
                      placement="top"
                      delay={{ show: 200 }}
                      target="_pm_drp"
                      text="Select a custom date range"
                    />

                    <button
                      disabled={this.state.loading && !this._IS_AUTO_RELOADING}
                      style={
                        this.state.showInputTime ? { display: "none" } : {}
                      }
                      className="selected-date-range-btn text-nowrap nofocus btn btn-outline-secondary"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState(
                          {
                            showInputTime: true,
                          },
                          () => {
                            this.setState({ range: this.parseTime() });
                          },
                        );
                      }}
                    >
                      <span style={{ marginRight: "8px" }} />
                      {this.parseTime()}
                    </button>

                    {this.state.showInputTime == true ? (
                      <span>
                        <Input
                          className="width-input form-control custom-input-header-modal"
                          bsSize="xs"
                          value={this.handleCustomRange()}
                          autoFocus
                          type="text"
                          invalid={this.state.invalidCustomRange}
                          disabled={this.state.loading}
                          onKeyDown={(e) => {
                            if (
                              e.key == "Enter" &&
                              !this.state.invalidCustomRange
                            ) {
                              e.preventDefault();
                              this.submitCustomRange();
                            } else if (
                              e.key == "Enter" &&
                              this.state.invalidCustomRange
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            if (this._AUTO_RELOAD_TIMEOUT) {
                              clearTimeout(this._AUTO_RELOAD_TIMEOUT);
                            }
                            e.preventDefault();
                            let string = e.target.value;
                            this.setState({
                              invalidCustomRange: false,
                              isCustom: true,
                              range: string,
                            });
                          }}
                        />
                        <FormFeedback>
                          {this.state.invalidCustomRangeMsg}
                        </FormFeedback>
                        {!this.state.invalidCustomRangeMsg && (
                          <FormText
                            color="muted"
                            className="d-flex align-items-start"
                          >
                            <span
                              className="icon-info mr-1"
                              style={{ fontSize: "120%" }}
                            />
                            Press "Enter" to submit
                          </FormText>
                        )}
                      </span>
                    ) : (
                      <span />
                    )}

                    {this._view_form &&
                    this._view_form.isInitialized() &&
                    this._view_form.getEntry("offset") !== undefined ? (
                      <ButtonGroup className="ml-2">
                        <ReactOButton
                          icon="close-outline"
                          disabled={
                            this.state.loading && !this._IS_AUTO_RELOADING
                          }
                          onClick={() => {
                            this._view_form.handleFormChange("offset", false);
                            const snapStime = parseInt(
                              this._view_form.getEntry("snapStime"),
                            );
                            const snapEtime = parseInt(
                              this._view_form.getEntry("snapEtime"),
                            );
                            this._view_form.handleFormChange(
                              "stime",
                              snapStime - (snapStime % 60),
                            );
                            this._view_form.handleFormChange(
                              "etime",
                              snapEtime - (snapEtime % 60),
                            );
                            this._view_form.submit();
                          }}
                        />
                      </ButtonGroup>
                    ) : null}
                  </div>

                  {this.state.tagsView &&
                    this.state.data.measures_list &&
                    this.getAppContext().authHandler.getAccountData()
                      .smart_notifications &&
                    this.getAppContext().authHandler.getAccountData()
                      .smart_notifications == "yes" && (
                      <span>
                        <Input
                          type="text"
                          className="form-input-text"
                          placeholder="Tags search"
                          bsSize="md"
                          disabled={this.state.loading}
                          onChange={(e) => {
                            this.setState({ searchKey: e.target.value });
                          }}
                          value={this.state.searchKey}
                        />
                      </span>
                    )}
                </ReactOActionBar>
              </ReactOForm>
            </div>
          </div>
          <div className="d-flex justify-content-between flex-grow-1 mt-3">
            <div style={{ marginRight: "-0.5em", marginTop: "0.5em" }}>
              <ReactOForm
                onControllerReady={(form_controller) => {
                  this.toggleViewForm = form_controller;
                }}
                onFormDataChange={(new_data) => {
                  if (new_data.toggleView == "on") {
                    this.setState({ tagsView: true });
                  } else if (new_data.toggleView == "off") {
                    this.setState({
                      tagsView: false,
                      selectedTags: [],
                      filteredDataTags: this.state.data.measures_list,
                    });
                  }
                }}
              >
                <>
                  {this.props.match.params.status == "active" &&
                    this.getAppContext().authHandler.getAccountData()
                      .smart_notifications &&
                    this.getAppContext().authHandler.getAccountData()
                      .smart_notifications == "yes" &&
                    !this.props.match.params.measureid && (
                      <>
                        <strong
                          className={`sub-title mr-2 ${
                            this.state.loading ? "text-gray400" : ""
                          }`}
                          style={{
                            display: "inline-block",
                            paddingTop: "1.2em",
                          }}
                        >
                          {`Toggle measures tags`}
                        </strong>
                        <div style={{ display: "inline-block" }}>
                          <ReactOFormInput
                            type="switch"
                            default="on"
                            data_key="toggleView"
                            disabled={this.state.loading}
                          />
                        </div>
                      </>
                    )}
                </>
              </ReactOForm>
            </div>

            <div>
              {this.getAppContext().isCloud() ? (
                <div className="text-right">
                  <small className="text-muted text-right">
                    {this.state.conf_set &&
                    this.state.conf_set.probe_status == "not_deployed" &&
                    this.state.conf_set.sync_status == 1 ? (
                      <span>Probe not deployed</span>
                    ) : this.state.conf_set &&
                      this.state.conf_set.probe_status == "maintenance" &&
                      this.state.conf_set.sync_status == 1 ? (
                      <span>Probe in maintenance</span>
                    ) : this.state.conf_set &&
                      this.state.conf_set.probe_status == "deployed" &&
                      this.state.conf_set.sync_status == 0 ? (
                      <span>
                        Probe <span className="text-danger">Offline</span>
                      </span>
                    ) : this.state.conf_set &&
                      this.state.conf_set.probe_status == "not_deployed" &&
                      this.state.conf_set.sync_status == 0 ? (
                      <span>
                        Probe not deployed{" "}
                        <span className="text-danger">Offline</span>
                      </span>
                    ) : this.state.conf_set &&
                      this.state.conf_set.probe_status == "maintenance" &&
                      this.state.conf_set.sync_status == 0 ? (
                      <span>
                        Probe in maintenance{" "}
                        <span className="text-danger">Offline</span>
                      </span>
                    ) : (
                      <div className="mb-4" />
                    )}
                  </small>
                </div>
              ) : (
                <div></div>
              )}
              <small className="text-muted">
                Most recent measure at:{" "}
                <strong>
                  {this.state.data.last_update
                    ? this.getAppContext()
                        .momentjs(this.state.data.last_update, "X")
                        .format("L LT")
                    : "-"}
                </strong>
              </small>
            </div>
          </div>
        </Section>
        <Section className="mx-4 mb-2" designType="wide">
          <Row>
            {!this.props.match.params.measureid &&
              this.state.tagsView &&
              this.getAppContext().authHandler.getAccountData()
                .smart_notifications &&
              this.getAppContext().authHandler.getAccountData()
                .smart_notifications == "yes" && (
                <Col md={12}>
                  {(this.state.loading &&
                    this.state.persistentTags &&
                    this.state.countTag) ||
                  (!this.state.loading && this.state.countTag)
                    ? this.state.countTag
                        .sort((a, b) => {
                          const aSelected = this.state.selectedTags.includes(a);
                          const bSelected = this.state.selectedTags.includes(b);

                          if (aSelected && !bSelected) return -1;
                          if (!aSelected && bSelected) return 1;

                          const countDiff =
                            (tagCounts[b] || 0) - (tagCounts[a] || 0);
                          if (countDiff !== 0) return countDiff;

                          return a.localeCompare(b);
                        })
                        .filter((tag) => !disabledTags[tag])
                        .map((tag) => {
                          const count = tagCounts[tag] || 0;
                          const isSelected =
                            this.state.selectedTags.includes(tag);
                          let background =
                            "bg-white border-gray700 text-gray700 ";
                          if (this.state.searchKey && search.includes(tag)) {
                            background =
                              "selected-bg border-primary text-primary ";
                          }
                          return (
                            <Badge
                              key={tag}
                              style={{
                                fontSize: "16px",
                                cursor: this.state.loading
                                  ? "unset"
                                  : "pointer",
                                fontWeight: isSelected ? "700" : "400",
                              }}
                              pill
                              className={`border ${background} mr-2 my-1 ${
                                isSelected ? "border-3 text-gray800 " : ""
                              }`}
                              onClick={() => {
                                if (!this.state.loading) {
                                  this.handleTagClick(tag);
                                }
                              }}
                            >
                              {tag}
                              <span style={{ fontWeight: "400" }}>
                                ({count})
                              </span>
                            </Badge>
                          );
                        })
                    : null}
                  <div className="mb-2">
                    {(this.state.loading &&
                      this.state.persistentTags &&
                      this.state.countTag) ||
                    (!this.state.loading && this.state.countTag)
                      ? this.state.countTag
                          .sort((a, b) => {
                            const countDiff =
                              (tagCounts[b] || 0) - (tagCounts[a] || 0);
                            return countDiff !== 0
                              ? countDiff
                              : a.localeCompare(b);
                          })
                          .filter((tag) => disabledTags[tag])
                          .map((tag) => {
                            const count = tagCounts[tag] || 0;
                            let background = "bg-white ";
                            if (this.state.searchKey && search.includes(tag)) {
                              background = "selected-bg-secondary";
                            }
                            return (
                              <Badge
                                key={tag}
                                style={{
                                  fontSize: "16px",
                                  cursor: "",
                                  color: "#949ca3ff",
                                  fontWeight: "400",
                                }}
                                pill
                                className={`border mr-2 my-1 ${background} border-muted`}
                              >
                                {tag}{" "}
                                <span style={{ fontWeight: "400" }}>
                                  ({count})
                                </span>
                              </Badge>
                            );
                          })
                      : null}
                  </div>
                </Col>
              )}
          </Row>
          <div className="d-flex justify-content-between">
            <div className="text-gray600">
              {!this.state.loading &&
              this.state.selectedTags &&
              this.state.selectedTags.length > 0 ? (
                tests.length != 1 ? (
                  <strong className="mr-2">
                    These measures are heterogeneous, cannot aggregate them for
                    overall chart
                  </strong>
                ) : dataLength > 1 ? (
                  <Link
                    to={{
                      pathname: `/${this.props.match.params.probeuid}/active/aggregate`,
                      state: {
                        mlist,
                        selectedTags: this.state.selectedTags,
                      },
                    }}
                  >
                    <strong
                      style={{ cursor: "pointer" }}
                      className="mr-2 text-primary link-color"
                    >
                      These measures are homogeneous, click here to generate
                      aggregate chart
                    </strong>
                  </Link>
                ) : null
              ) : null}
            </div>
          </div>
        </Section>
        {this.props.match.params.measureid === undefined ? ( // && !this.state.loading
          <_LoadingWrapper minHeight loadingPlug={this.state.loading}>
            {this.props.match.params.status == "archived" ||
            this.props.match.params.status == "paused" ? (
              <div>
                <Panel className="mx-4 mb-2" bodyClassName="p-0" rounded>
                  {this.state.data.measures_list ? (
                    <MeasuresOveralsList
                      data={
                        !this.state.showUntagged
                          ? this.state.filteredDataTags
                          : this.state.measuresWithNoTags
                      }
                      mlist={mlist}
                      selectedTags={this.state.selectedTags}
                      cssids={this.props.location?.state?.cssids || []}
                    />
                  ) : (
                    <span className="p-3">No archived measures</span>
                  )}
                </Panel>
              </div>
            ) : (
              <div>
                {this.state.filteredDataTags &&
                  this.state.filteredDataTags.length > 0 &&
                  this.state.filteredDataTags.filter((elem) => {
                    return elem.paused == null;
                  }).length > 0 && (
                    <Panel className="mx-4 mb-2" bodyClassName="p-0" rounded>
                      <MeasuresOveralsList
                        data={
                          !this.state.showUntagged
                            ? this.state.filteredDataTags.filter((elem) => {
                                return elem.paused == null;
                              })
                            : this.state.measuresWithNoTags
                        }
                        mlist={mlist}
                        selectedTags={this.state.selectedTags}
                        cssids={this.props.location?.state?.cssids || []}
                      />
                    </Panel>
                  )}

                {!this.state.tagsView &&
                  this.state.filteredDataTags &&
                  this.state.filteredDataTags.filter((elem) => {
                    return elem.paused != null;
                  }).length > 0 && (
                    <Panel className="mx-4 mb-2" bodyClassName="p-0" rounded>
                      <MeasuresOveralsList
                        data={this.state.filteredDataTags.filter((elem) => {
                          return elem.paused != null;
                        })}
                        mlist={mlist}
                        selectedTags={this.state.selectedTags}
                        cssids={this.props.location?.state?.cssids || []}
                      />
                    </Panel>
                  )}
              </div>
            )}
          </_LoadingWrapper>
        ) : (
          <_LoadingWrapper
            minHeight
            loadingPlug={this.state.loading && !this._IS_AUTO_RELOADING}
          >
            <MeasureBssidsList
              viewrange={this.state.viewrange}
              data={this.state.filteredData ? this.state.filteredData : null}
              freqData={this.state.freqData ? this.state.freqData : null}
              mlist={mlist}
              selectedTags={this.state.selectedTags}
              cssids={this.props.location?.state?.cssids || []}
            />
          </_LoadingWrapper>
        )}
        {!this.state.loading &&
          this.state.tagsView &&
          this.getAppContext().authHandler.getAccountData()
            .smart_notifications && (
            <Section
              className="d-flex justify-content-between align-items-center mx-4 mb-3"
              designType="wide"
            >
              <ReactOForm
                onControllerReady={(form_controller) => {
                  this.showTags_form = form_controller;
                }}
                onFormDataChange={(new_data) => {
                  if (new_data.showUntagged == "on") {
                    // this.handleMeasuresWithoutTags("on");
                    this.setState({ showUntagged: true });
                  } else if (new_data.showUntagged == "off") {
                    // this.handleMeasuresWithoutTags("off");
                    this.setState({ showUntagged: false });
                  }
                }}
              >
                {this.state.measuresWithNoTags &&
                this.props.match.params.status == "active" &&
                this.getAppContext().authHandler.getAccountData()
                  .smart_notifications &&
                this.getAppContext().authHandler.getAccountData()
                  .smart_notifications == "yes" ? (
                  this.state.measuresWithNoTags.length > 0 ? (
                    <>
                      <strong
                        className="sub-title mr-2"
                        style={{ display: "inline-block" }}
                      >
                        {`Show ${this.state.measuresWithNoTags.length} measures with no tag`}
                      </strong>
                      <div style={{ display: "inline-block" }}>
                        <ReactOFormInput
                          type="switch"
                          data_key="showUntagged"
                        />
                      </div>
                    </>
                  ) : (
                    <strong
                      className="sub-title"
                      style={{ display: "inline-block" }}
                    >
                      0 measures with no tag
                    </strong>
                  )
                ) : null}
              </ReactOForm>
            </Section>
          )}
      </Section>
    );
  }
}

export default contextProvider(ProbeMeasures, {
  define: null,
});
